<template>

  <v-container fluid>
    <v-row justify="center" v-if="event.description">
      <v-col cols="12" md="10" lg="8" xl="6">
        <v-card elevation="0">
          <v-card-text class="pa-0" v-html="event.description">
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center" v-if="event.html_code">
      <v-col cols="12" md="10" lg="8" xl="6">
        <v-card elevation="0">
          <v-card-text class="pa-0" v-html="event.html_code">
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8" xl="6">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3" v-for="(room, idx) in event.rooms" :key="idx">
            <v-card @click="$router.push({name: 'Room', params: {id:room.id}})" hover>
              <v-img :src="room.preview_image"/>
              <v-card-title class="text-subtitle-1">
                {{ room.title }}
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <template v-if="event.sponsors.length>0 && event.sponsors_in_lobby">
      <v-divider/>
      <v-row justify="center">
        <v-col cols="12" md="10" lg="8" xl="6">
          <div class="text-subtitle-1 mt-6">{{
              event.sponsor_heading ? event.sponsor_heading : $t( 'foyer.sponsor_heading' )
            }}
          </div>
          <v-row align="stretch">
            <v-col v-for="(sponsor, idx) in event.sponsors" :key="idx" cols="12" sm="6" md="4"
                   lg="3"
                   xl="2">
              <sponsor :sponsor="sponsor" :show-name="event.sponsors_show_name"></sponsor>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import Sponsor from '@/components/Sponsor';
import { mapMutations, mapState } from 'vuex';
import router from '@/router';


export default {
  name: 'Foyer',
  components: { Sponsor },
  computed: {
    ...mapState( ['event', 'frame'] ),
  },
  mounted ()
  {
    this.setFoyerLoading(false)
    if ( !this.event.display_lobby && this.event.rooms && this.event.rooms.length > 0 )
    {
      router.push( { name: 'Room', params: { id: this.event.rooms[ 0 ].id } } );
    }
  },
  methods: {
    ...mapMutations( ['setFoyerLoading'] ),
  },
};
</script>

<style scoped>

</style>